import { render } from "./NewPost.vue?vue&type=template&id=1507ea55&scoped=true"
import script from "./NewPost.vue?vue&type=script&lang=js"
export * from "./NewPost.vue?vue&type=script&lang=js"

import "./NewPost.vue?vue&type=style&index=0&id=1507ea55&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1507ea55"

export default script